import { useEffect, useState } from "react";

export default function Des({ src, launch, loading, setLoading, position_bottom, setPositionBottom, currentDice }) {
    const [bottom, setBottom] = useState(15);
    const [rotate, setRotate] = useState(0);
    const [fade, setFade] = useState(false);
    const [opacity, setOpacity] = useState(1);
    const [scale, setScale] = useState(1);
    const [showResult, setShowResult] = useState(false);

    const anim = () => {
        const audio = new Audio('/assets/sounds/dice-entrance.mp3');
        audio.play();
        
        // Start jump animation with deceleration
        setBottom(50);
        setRotate((prev) => prev + 1800);



        setTimeout(() => {
            const newAudio = new Audio('/assets/sounds/dice-launch.mp3');
            newAudio.play();
        }, 0);

        setTimeout(() => {
            setFade(true);
            setTimeout(() => {
                setOpacity(0);
                setScale(1.5);
            }, 100);
        }, 1600);

        setTimeout(() =>{
            setBottom(15);
        },1000)

        setTimeout(() => {
            
            // show the result after 2 seconds
            setTimeout(() => {
                setShowResult(true);
            }, 500);
            
            
            // Hide the result after 2 seconds
            setTimeout(() => {
                setShowResult(false);
            }, 3000);
        }, 1500);
    };

    useEffect(() => {
        setFade(false);
    }, [position_bottom]);

    return (
        <>
            <div style={{transitionDuration: '0.5s', opacity: (position_bottom === 0) ? 1 : 0}}>
                <img
                    alt="des"
                    style={{
                        transform: `rotate(${rotate}deg)`,
                        // Updated transition with deceleration on ascent and acceleration on descent
                        transition: 'bottom 0.8s cubic-bezier(0.42, 0, 0.58, 1), transform 1500ms cubic-bezier(.53,.93,.66,.37)',
                        width: '20%',
                        position: 'fixed',
                        left: '40%',
                        bottom: `${bottom}%`,
                    }}
                    src={src}
                />
                {
                !loading && !showResult &&
                <div
                onClick={() => {anim(); launch(); setLoading(true); setTimeout(()=>{setPositionBottom(-100)}, 3000); setTimeout(()=>{setLoading(false)}, 5100)}}
                style={{
                    boxShadow: '12px 14px 16px rgba(0,0,0,0.4)',
                    textAlign: "center",
                    color: '#004A7C',
                    backgroundColor: 'white',
                    borderRadius: '2em',
                    bottom: '5%',
                    padding: '8px',
                    width: '80%',
                    position: 'fixed',
                    left: '10%',
                    cursor: "pointer",
                    textTransform: "uppercase"
                }}
                >
                Roll the dice
                </div>
                }
                {
                showResult &&
                <div
                style={{
                    color: 'white',
                    bottom: '5%',
                    padding: '10px',
                    width: '80%',
                    position: 'fixed',
                    left: '10%',
                    fontStyle: 'normal',
                    fontWeight: '400',
                    fontSize: '2em',
                    lineHeight: '48px',
                    textAlign: 'center',
                    textTransform: 'uppercase',
                }}
                >
                IT'S A {currentDice}!
                </div>
                }
            </div>
            {
                fade &&
                <div style={{transformOrigin: 'center' , scale: scale, transitionDuration: '1000ms', opacity: opacity, top: 0, left: 0, margin: 0, height: '100vh', width: '100vw', position: 'fixed', zIndex: 15000, background: 'url("./assets/dés/fade.png")', backgroundSize: '100%'}}>

                </div>
            }
        </>
    );
}